import {
  userApi,
  type UserProfile,
  type UpdateUserRequest,
} from "@/shared/api/user";

export const usersApi = {
  fetchMe: () => userApi.getProfile(),
  updateMe: (data: UpdateUserRequest) => userApi.updateProfile(data),
  fetchById: (userId: string) => userApi.getUserById(userId),
  search: (query: string) => userApi.searchUsers(query),
};

export type { UserProfile, UpdateUserRequest };
